import clsx from 'clsx';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

function Button(props) {
  const { sizeType, children, href, type, onClick } = props;

  return (
    <>
      {href ? (
        <StyledLink to={href} className={clsx(sizeType)} {...props}>
          {children}
        </StyledLink>
      ) : (
        <StyledBtn
          type={type ? type : 'button'}
          className={clsx(sizeType)}
          onClick={onClick}
          {...props}
        >
          {children}
        </StyledBtn>
      )}
    </>
  );
}

Button.defaultProps = {
  sizeType: 'medium', // medium, small
};

const globalBtnStyle = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  max-width: 33rem;
  width: fit-content;
  height: 6rem;
  box-sizing: border-box;
  padding: 2rem;
  background: var(--background);
  border: 1px solid var(--grayLv2);
  border-radius: 1.6rem;
  font-family: var(--pretendard);
  font-size: 1.6rem;
  line-height: 2.2rem;
  color: var(--surface);

  &:hover {
    border: 1px solid var(--surface);
  }

  &.small {
    height: 3rem;
    padding: 0.5rem 1.5rem;
    boder-radius: 5rem;
    color: var(--grayLv3);
    font-size: 1.4rem;
    line-height: 2rem;

    &:hover {
      color: var(--surface);
    }
  }
`;

const StyledBtn = styled.button`
  ${globalBtnStyle}
`;

const StyledLink = styled(Link)`
  ${globalBtnStyle}
`;

export default Button;
